module.exports = __webpack_public_path__ + "img/upload_cross.79ad5d1b.svg";